var _circle, _g, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMileageTrackerUpsell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_15703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 123,
    height: 123
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.2542,
    cy: 63.2542,
    r: 61.2542,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_15703)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.575195,
    y: -7.26379,
    width: 132.48,
    height: 131.055,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.575195,
    y: -7.26379,
    width: 132.48,
    height: 131.055,
    fill: "url(#paint0_linear_1_15703)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4082 73.464H24.2816C24.18 73.464 24.0921 73.5394 24.0732 73.6392C22.8411 80.1504 23.0795 81.3974 26.5394 81.3974C21.1719 81.3974 22.2878 85.8473 23.6624 94.8005C23.675 94.8826 23.7348 94.9516 23.8148 94.974L31.3616 97.0871C31.4923 97.1237 31.6234 97.0244 31.633 96.889C32.5158 84.3903 51.1449 82.7829 53.3792 96.9732C53.3956 97.077 53.4852 97.1585 53.5903 97.1585H71.8203C71.9342 97.1585 72.0276 97.0653 72.0337 96.9515C72.6578 85.3049 90.5396 81.5148 93.5736 97.0032C93.5912 97.0931 93.6662 97.1667 93.7572 97.1779C97.7128 97.6661 100.094 97.1299 103.84 94.7407C103.856 94.7308 103.87 94.7191 103.882 94.7052C104.417 94.0928 104.669 92.4914 104.71 90.0713C104.757 87.3422 104.524 83.656 103.885 80.7516C103.872 80.6912 103.832 80.6399 103.777 80.6111C97.6998 77.4029 93.0921 76.6105 84.1408 75.9015C84.1036 75.8985 84.0665 75.8854 84.0359 75.8642C68.3647 65.0679 56.6194 63.8254 28.4774 73.4524C28.4554 73.4599 28.4316 73.464 28.4082 73.464Z",
    fill: "url(#paint1_linear_1_15703)",
    stroke: "#648AEB",
    strokeWidth: 2.96182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3057 89.9656H104.71",
    stroke: "#648AEB",
    strokeWidth: 2.96182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8185 59.6069H37.2231",
    stroke: "#648AEB",
    strokeWidth: 2.96182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9011 59.8185H97.3057",
    stroke: "#648AEB",
    strokeWidth: 2.96182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.285 41.3597L87.5208 36.1239",
    stroke: "#648AEB",
    strokeWidth: 2.96182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1849 36.1239L45.4207 41.3597",
    stroke: "#648AEB",
    strokeWidth: 2.96182,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5121,
    cy: 97.4758,
    r: 5.71208,
    fill: "#97B1F1",
    stroke: "#648AEB",
    strokeWidth: 2.96182
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.7081,
    cy: 97.4758,
    r: 5.71208,
    fill: "#97B1F1",
    stroke: "#648AEB",
    strokeWidth: 2.96182
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_1_15703",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7484 72.3624C100.299 72.5576 100.905 72.2698 101.085 71.7141C102.857 66.2555 103.421 60.4725 102.733 54.7665C102.003 48.7101 99.8826 42.9046 96.5369 37.8037C93.1913 32.7029 88.7114 28.4448 83.4473 25.3622C78.1832 22.2797 72.2776 20.4563 66.192 20.0345C60.1064 19.6126 54.0057 20.6038 48.3667 22.9306C42.7277 25.2573 37.7031 28.8566 33.6857 33.4471C29.6683 38.0376 26.7668 43.495 25.2081 49.3927C23.7396 54.9492 23.5005 60.7548 24.5021 66.4056C24.604 66.9808 25.1645 67.3495 25.7368 67.2322L26.323 67.1121C26.8953 66.9948 27.2626 66.4359 27.1617 65.8605C26.2435 60.6199 26.4704 55.2381 27.832 50.0861C29.2837 44.593 31.9861 39.51 35.7279 35.2344C39.4698 30.9588 44.1497 27.6065 49.4018 25.4393C54.654 23.2722 60.3362 22.349 66.0043 22.7419C71.6725 23.1348 77.173 24.8331 82.0759 27.7042C86.9789 30.5752 91.1515 34.5412 94.2676 39.2922C97.3837 44.0432 99.359 49.4504 100.039 55.0913C100.677 60.3818 100.159 65.7434 98.5264 70.8073C98.3471 71.3633 98.6338 71.9674 99.1845 72.1626L99.7484 72.3624Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.7484 72.3624C100.299 72.5576 100.905 72.2698 101.085 71.7141C102.857 66.2555 103.421 60.4725 102.733 54.7665C102.003 48.7101 99.8826 42.9046 96.5369 37.8037C93.1913 32.7029 88.7114 28.4448 83.4473 25.3622C78.1832 22.2797 72.2776 20.4563 66.192 20.0345C60.1064 19.6126 54.0057 20.6038 48.3667 22.9306C42.7277 25.2573 37.7031 28.8566 33.6857 33.4471C29.6683 38.0376 26.7668 43.495 25.2081 49.3927C23.7396 54.9492 23.5005 60.7548 24.5021 66.4056C24.604 66.9808 25.1645 67.3495 25.7368 67.2322L26.323 67.1121C26.8953 66.9948 27.2626 66.4359 27.1617 65.8605C26.2435 60.6199 26.4704 55.2381 27.832 50.0861C29.2837 44.593 31.9861 39.51 35.7279 35.2344C39.4698 30.9588 44.1497 27.6065 49.4018 25.4393C54.654 23.2722 60.3362 22.349 66.0043 22.7419C71.6725 23.1348 77.173 24.8331 82.0759 27.7042C86.9789 30.5752 91.1515 34.5412 94.2676 39.2922C97.3837 44.0432 99.359 49.4504 100.039 55.0913C100.677 60.3818 100.159 65.7434 98.5264 70.8073C98.3471 71.3633 98.6338 71.9674 99.1845 72.1626L99.7484 72.3624Z",
    stroke: "#648AEB",
    strokeWidth: 5.92364,
    mask: "url(#path-11-inside-1_1_15703)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-2_1_15703",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6 65.1262C78.1355 65.3597 78.7625 65.1159 78.9601 64.5661C80.0037 61.6615 80.1846 58.5083 79.4685 55.4906C78.6707 52.1289 76.8029 49.1172 74.146 46.9085C71.4892 44.6998 68.1869 43.4136 64.7361 43.2434C61.6384 43.0906 58.5713 43.8445 55.9062 45.4011C55.4017 45.6958 55.2765 46.3568 55.604 46.8406L56.0148 47.4476C56.3422 47.9314 56.998 48.0541 57.5067 47.7667C59.6572 46.5519 62.1145 45.9661 64.5957 46.0885C67.4303 46.2283 70.1427 47.2848 72.3251 49.099C74.5074 50.9132 76.0416 53.387 76.6969 56.1483C77.2705 58.5655 77.1435 61.0885 76.3419 63.4247C76.1523 63.9773 76.3927 64.5996 76.9282 64.8332L77.6 65.1262Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.6 65.1262C78.1355 65.3597 78.7625 65.1159 78.9601 64.5661C80.0037 61.6615 80.1846 58.5083 79.4685 55.4906C78.6707 52.1289 76.8029 49.1172 74.146 46.9085C71.4892 44.6998 68.1869 43.4136 64.7361 43.2434C61.6384 43.0906 58.5713 43.8445 55.9062 45.4011C55.4017 45.6958 55.2765 46.3568 55.604 46.8406L56.0148 47.4476C56.3422 47.9314 56.998 48.0541 57.5067 47.7667C59.6572 46.5519 62.1145 45.9661 64.5957 46.0885C67.4303 46.2283 70.1427 47.2848 72.3251 49.099C74.5074 50.9132 76.0416 53.387 76.6969 56.1483C77.2705 58.5655 77.1435 61.0885 76.3419 63.4247C76.1523 63.9773 76.3927 64.5996 76.9282 64.8332L77.6 65.1262Z",
    stroke: "#648AEB",
    strokeWidth: 5.92364,
    mask: "url(#path-12-inside-2_1_15703)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5622,
    cy: 59.7127,
    r: 2.64448,
    fill: "white",
    stroke: "#648AEB",
    strokeWidth: 2.96182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6758 46.8807L61.9162 56.5533C61.9534 56.6109 61.9603 56.683 61.9349 56.7466L61.2274 58.5152C61.1771 58.6411 61.023 58.6878 60.9112 58.611L50.7211 51.6118C50.6798 51.5834 50.6499 51.5412 50.6367 51.4927L49.0562 45.6646C49.0146 45.511 49.151 45.3682 49.3063 45.4027L55.5439 46.7888C55.5982 46.8009 55.6456 46.8339 55.6758 46.8807Z",
    fill: "white",
    stroke: "#648AEB",
    strokeWidth: 2.96182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0093 77.2422C67.8319 72.4395 50.0755 71.6884 41.7198 77.2122C41.5491 77.3251 41.6335 77.5804 41.8382 77.5804H72.8648C73.049 77.5804 73.1443 77.3674 73.0093 77.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.668 33.1621V25.7576",
    stroke: "#648AEB",
    strokeWidth: 2.96182,
    strokeLinecap: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5083,
    cy: 63.5083,
    r: 61.9917,
    stroke: "#CBD8F8",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_15703",
    x1: 66.8152,
    y1: -7.26379,
    x2: 67.2,
    y2: 90.4204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EDFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_15703",
    x1: 33,
    y1: 87.9999,
    x2: 88.5,
    y2: 78.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97B1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9CCFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageTrackerUpsell);
export default __webpack_public_path__ + "static/media/mileageTrackerUpsell.bd885bbcfb342daced9f6a535b5b34d2.svg";
export { ForwardRef as ReactComponent };